import ApiService from "../common/api.service";
import JwtService from "../common/jwt.service";
import { SET_ERROR } from "./mutations.type";
import CacheStorage from "../common/cache.storage";

const state = {
    order: {
        orderId: "",
        date: "",
        merchantId: "",
        orderMeals: [
            { name: "", price: 0, quantity: 0 }
        ],
        phone: "",
        amount: 0,
        status: { valify: false, ready: false, sending: false, complete: false }
    },
    orders: [],
    orderHistory: []
}


const getters = {
    order() {
        return state.order
    },
    orders() {
        return state.orders
    },
    orderHistory() {
        return state.orderHistory
    },
}

const actions = {
    async fetchOrders(context, slug) {
        return new Promise(resolve => {
            ApiService.get("order/list", slug)
                .then(({ data }) => {
                    context.commit("setOrders", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    async fetchOrder(context, orderSlug) {
        return new Promise(resolve => {
            ApiService.get("order", orderSlug)
                .then((resp) => {
                    if (resp.status == 400 && resp.data.code == 5) {
                        CacheStorage.removeOrderRecord(orderSlug)
                        let orderHistory = CacheStorage.getOrderRecord()
                        context.commit("setOrderHistory", orderHistory);
                    } else if (resp.status == 200) {
                        context.commit("setOrder", resp.data);
                        resolve(resp.data);
                    } else {
                        console.log(resp)
                    }
                })
                .catch(function (error) {
                    console.log(error)
                });
        });
    },
    async orderEdit(context) {
        return new Promise(resolve => {
            ApiService.update("order", state.order)
                .then(({ data }) => {
                    context.commit("setOrder", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    async orderSetStatus(context, order) {
        return new Promise(resolve => {
            ApiService.update("order", order, order.orderId)
                .then(({ data }) => {
                    context.commit("setOrder", data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    async orderVerify(context, verifyCode) {
        return new Promise(resolve => {
            ApiService.setHeader(JwtService.SMS_TOKEN_KEY)
            ApiService.post("sms/verification", { verifyCode: verifyCode})
            .then((resp) => {
                if (resp.status != 200 && resp.datSa) {
                    alert(resp.data.errors.body)
                } else {
                    context.commit("setOrder", resp.data);
                    JwtService.destroyToken(JwtService.SMS_TOKEN_KEY);
                    resolve(resp.data);
                    //todo 驗證成功再把訂單儲存時間延長 處理token 還有多筆訂單驗證
                }
                ApiService.unsetHeader()
            })
            .catch((response) => {
                ApiService.setHeader(JwtService.ID_TOKEN_KEY)
                context.commit(SET_ERROR, response.data.errors);
            });
        });
    },
    hasOrderUnfinished(){
        var orderHistory = CacheStorage.getOrderRecord()
        if(orderHistory.length > 1){
            return orderHistory[orderHistory.length-1].orderId
        }
        return false
    },
    async orderCreate(context) {
        return new Promise((resolve, reject) => {
            var now = new Date();
            state.order.date = now.toISOString();
            ApiService.post("order", state.order)
                .then((resp) => {
                    if (resp.status != 200 && resp.data) {
                        reject(resp.data)
                    }else{
                        context.commit("setOrder", resp.data.order);
                        JwtService.saveToken(JwtService.SMS_TOKEN_KEY, resp.data.token);
                        CacheStorage.addOrderRecord(resp.data.order.orderId)
                        resolve(resp.data.order);
                    }
                })
                .catch((response) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    menuQuantityToOrder(context, menu) {
        var order = {
            orderId: "",
            phone: "",
            date: "",
            merchantId: menu.merchantId,
            deliveryLocation: menu.deliveryLocation,
            deliveryTime: menu.deliveryTime,
            orderMeals: [],
            amount: 0,
            status: { valify: false, ready: false, sending: false, complete: false }
        };
        for (let index in menu.menuMeal) {
            if (menu.menuMeal[index].quantity > 0) {
                let meal = { name: "", price: 0, quantity: 0 }
                meal.name = menu.menuMeal[index].name;
                meal.price = menu.menuMeal[index].price;
                meal.quantity = menu.menuMeal[index].quantity;
                order.amount += meal.quantity * meal.price
                order.orderMeals.push(meal);
            }
        }
        context.commit("setOrder", order);
    },
    trackOrderHistory(context) {
        let orderHistory = CacheStorage.getOrderRecord()
        context.commit("setOrderHistory", orderHistory);
    }
}

const mutations = {
    setOrder(state, order) {
        state.order = order
    },
    setOrders(state, orders) {
        state.orders = orders
    },
    setOrderHistory(state, orderHistory) {
        state.orderHistory = orderHistory
    },
}

export default {
    state,
    getters,
    actions,
    mutations
};
